import Loading from '@components/shared/Loading';
import { useCurrentReport, useCurrentReports } from '../../hooks/useReports';
import { Alert } from '@mui/material';
import { PerformanceByRetailer } from './PerformanceByRetailer';

export const PerformanceByRetailerContainer = () => {
  const { report, loading } = useCurrentReport();
  const { reports } = useCurrentReports();

  if (loading) return <Loading />;

  if (!report)
    return <Alert severity="error">Error loading campaign data.</Alert>;

  return <PerformanceByRetailer report={report} allReports={reports} />;
};
